// Single source of truth for the 9-state POStatus palette per
// planning/plans/2026-05-29-inventory-skuvault-inspired-roadmap.md §4.5a.
//
// PO_STATUS_PALETTE is exported so adjacent surfaces (e.g. timeline rows that
// render from→to states) can reuse the same color language without duplicate
// hex/Tailwind drift. Split out of POStatusBadge.tsx so that file only
// exports components (react-refresh/only-export-components).

import type { POStatus } from '../mocks/data/inventory/purchase-orders'

export const PO_STATUS_PALETTE: Record<POStatus, string> = {
  draft: 'bg-slate-100 text-slate-700 ring-slate-200',
  sent: 'bg-sky-100 text-sky-800 ring-sky-200',
  acknowledged: 'bg-cyan-100 text-cyan-800 ring-cyan-200',
  in_transit: 'bg-indigo-100 text-indigo-800 ring-indigo-200',
  partial_received: 'bg-amber-100 text-amber-800 ring-amber-200',
  received: 'bg-emerald-100 text-emerald-800 ring-emerald-200',
  disputed: 'bg-rose-100 text-rose-800 ring-rose-200',
  closed: 'bg-slate-200 text-slate-600 ring-slate-300',
  cancelled: 'bg-slate-100 text-slate-400 ring-slate-200',
}
